import styled from 'styled-components';

export const Video = styled.video`
  width: 100%;
  height: 500px;
`;
